import { IStackStyles, Stack } from "@fluentui/react";
import React from "react";
import { useComponentLogger } from "../../../shared/logging";
import { media } from "../../../styles/media";
import { WithoutNavBarPageLayoutProps } from "../PageLayout.types";

const minHeight = "100vh";

const rootStyles: IStackStyles = {
    root: {
        width: "100%",
        minHeight: minHeight
    }
};

const containerStyles: IStackStyles = {
    root: {
        overflowX: "hidden",
        width: "100vw",
        minHeight: minHeight // IE 11 needs explicit height
    }
};

const contentStyles: IStackStyles = {
    root: {
        boxSizing: "border-box",
        width: "100%",
        selectors: {
            [media.maxS]: {
                // To avoid overflow issues caused by margin + fixed width, padding is used with a box-sizing of border-box
                // to achieve the same visual outcome as margin.
                padding: "0 16px 10px",
                width: "100%"
            },
            [media.minM]: {
                padding: "0 32px 10px",
                width: "100%" // IE 11 needs explicit width (here and below) for correct formatting
            },
            [media.minL]: {
                padding: "0 48px 10px",
                width: "100%"
            },
            [media.minXl]: {
                padding: "0 54px 10px",
                width: "100%"
            },
            [media.minXxl]: {
                // At this breakpoint, the content is at a flexible width and needs margin for centering.
                padding: "0 0 10px",
                margin: "0 auto",
                maxWidth: "1184px",
                width: "100%"
            },
            [media.minXxxl]: {
                padding: "0 0 10px",
                margin: "0 auto",
                maxWidth: "1184px",
                width: "100%"
            }
        }
    }
};

export const WithoutNavBarPageLayout: React.FC<WithoutNavBarPageLayoutProps> = ({
    messageBarContainer,
    children,
    id
}) => {
    useComponentLogger("WithoutNavBarPageLayout", id);

    return (
        <Stack horizontal={true} styles={rootStyles}>
            <Stack styles={containerStyles}>
                <main role="main" id={id} tabIndex={-1} style={{ outline: "none" }}>
                    <Stack>
                        {messageBarContainer}
                    </Stack>
                    <Stack verticalAlign="start" styles={contentStyles}>
                        {children}
                    </Stack>
                </main>
            </Stack>
        </Stack>
    );
};
